import * as XLSX from "xlsx";
import dayjs from "dayjs";

export const exportDailyRankingToExcel = (dayData) => {
  const workbook = XLSX.utils.book_new();

  const excelData = dayData.listTopUser.map((userTop, index) => {
    const user = userTop.user;
    const rank = userTop.rankInfo.rankDateToday;

    return {
      ID: user.id,
      "Mã KH": user.code,
      Họ: user.lastName,
      Tên: user.firstName,
      SĐT: user.phoneNumber,
      "Số Ngày Đăng": user.totalPostsInCurrentEvent,
      "Giờ post đầu": dayjs(rank.timeFirstValidPostInToday).format(
        "HH:mm:ss.SSS DD/MM/YYYY",
      ),
    };
  });

  // Tạo worksheet
  const worksheet = XLSX.utils.json_to_sheet(excelData);

  // Đặt tên cho worksheet
  const dateFormatted = dayjs(dayData.date).format("DD-MM-YYYY");
  XLSX.utils.book_append_sheet(workbook, worksheet, `Ranking_${dateFormatted}`);

  // Tạo tên file
  const fileName = `Bảng_xếp_hạng_${dateFormatted}.xlsx`;

  // Download file
  XLSX.writeFile(workbook, fileName);
};

export const exportWeeklyRankingToExcel = (weeklyData) => {
  const workbook = XLSX.utils.book_new();

  weeklyData.forEach((week, weekIndex) => {
    const excelData = week.listRankMain.map((userRank, index) => {
      return {
        ID: userRank.user.id,
        "Mã KH": userRank.user.code,
        Họ: userRank.user.lastName,
        Tên: userRank.user.firstName,
        SĐT: userRank.user.phoneNumber,
        "Tổng điểm": userRank.totalScore,
        "Số ngày tham gia": userRank.totalDays,
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const weekName = `Tuần_${weekIndex + 1}_${dayjs(week.startDate).format(
      "DD-MM",
    )}_${dayjs(week.endDate).format("DD-MM")}`;
    XLSX.utils.book_append_sheet(workbook, worksheet, weekName);
  });

  const fileName = `Bảng_xếp_hạng_tuần_${dayjs().format("DD-MM-YYYY")}.xlsx`;
  XLSX.writeFile(workbook, fileName);
};

export const exportMonthlyRankingToExcel = (rankingList, dateFrom, dateTo) => {
  const workbook = XLSX.utils.book_new();

  const excelData = rankingList.map((item, index) => {
    return {
      ID: item.user.id,
      "Mã KH": item.user.code,
      Họ: item.user.lastName,
      Tên: item.user.firstName,
      SĐT: item.user.phoneNumber,
      "Ngày hoạt động": item.user.totalPostsInCurrentEvent,
    };
  });

  const worksheet = XLSX.utils.json_to_sheet(excelData);
  const monthName = `Tháng_${dayjs(dateFrom).format("MM-YYYY")}`;
  XLSX.utils.book_append_sheet(workbook, worksheet, monthName);

  const fileName = `Thống_kê_tháng_${dayjs(dateFrom).format("MM-YYYY")}.xlsx`;
  XLSX.writeFile(workbook, fileName);
};
